import "./clickstream-web.min.js"

try {
    window.ClickstreamAnalytics.init({
        appId: 'prod',
        endpoint: 'https://analytics.collaterate.com/collect',
        pageType: window.PageType.multiPageApp,
        searchKeyWords: ['k'],
        isLogEvents: true,
    });

    reportABTesting();
    listenForLogInOut();

    // Report A/B testing results to Clickstream
    function reportABTesting () {
        // Get test results, filter to only enabled results, and rename them
        const testResults = tbgABTestContext && tbgABTestContext.rules && Object.entries(tbgABTestContext.rules).map(([testId, testBody]) => {
            if (testBody.enabled === 0) {
                return null;
            }

            const testName = 'ab_' + testId.replace(/-/g, '_');

            return { [testName]: testBody.enabled === 1 };
        }).filter(Boolean).reduce((prev, curr) => ({...prev, ...curr}), {}) || {};

        // // Remove tests from aws cache that are no longer being served
        // const awsCache = JSON.parse(window.localStorage.getItem('aws-solution/clickstream-web/userAttributesKey') || false);
        // const cachedTests = awsCache ? Object.keys(awsCache).filter(key => (/^ab_/.test(key))) : [];
        // cachedTests.forEach(test => {
        //     if (!Object.keys(testResults).includes(test)) {
        //         delete awsCache[test];
        //     }
        // });
        // // Save aws cache back with outdated tests removed
        // awsCache && window.localStorage.setItem('aws-solution/clickstream-web/userAttributesKey', JSON.stringify(awsCache));

        // Record test results for user
        ClickstreamAnalytics.setUserAttributes(testResults);
        ClickstreamAnalytics.record({ name: 'experience_impression', attributes: testResults });
    }

    function listenForLogInOut () {
        window.events.listen(window.events.USER_LOADED, {
            handleUser: function () {
                /*
                Note:
                Using sessionStorage will cause a "logged in" event any time a
                user opens a new tab. Leaving as-is for the time being, to
                potentially track tab use across a single session.
                */
                const loggedIn = window.sessionStorage.getItem('loggedIn');
                const user = globalpageglobals.cuser;
                const awsCache = JSON.parse(window.localStorage.getItem('aws-solution/clickstream-web/userAttributesKey'));

                if (!loggedIn && user || user && !awsCache['_user_id']) {
                    window.ClickstreamAnalytics.setUserId(user.id);
                    window.sessionStorage.setItem('loggedIn', 'yes');
                    return;
                }

                if (loggedIn && !user) {
                    window.ClickstreamAnalytics.setUserId(null);
                    window.sessionStorage.removeItem('loggedIn')
                    return;
                }
            }
        }, 'handleUser');
    }
} catch (e) {
    console.error(e);
}
